import { render, staticRenderFns } from "./menu-user.vue?vue&type=template&id=e2078df2&scoped=true&"
import script from "./menu-user.vue?vue&type=script&lang=js&"
export * from "./menu-user.vue?vue&type=script&lang=js&"
import style0 from "./menu-user.vue?vue&type=style&index=0&id=e2078df2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2078df2",
  null
  
)

export default component.exports